import PropTypes from "prop-types";
import { m } from "framer-motion";
import { NavLink as RouterLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// @mui
import { alpha, useTheme, styled } from "@mui/material/styles";
import {
  Box,
  Grid,
  Button,
  Container,
  Typography,
  LinearProgress,
  Stack,
  TextField,
  Link,
} from "@mui/material";
// hooks
import useResponsive from "src/hooks/useResponsive";
import useAuth from "src/hooks/useAuth";
// utils
import { fPercent } from "src/utils/formatNumber";
// _mock_
import { _skills } from "src/_mock";
// components
import Image from "src/components/Image";
import Iconify from "src/components/Iconify";
import { MotionViewport, varFade } from "src/components/animate";
import img1 from "src/assets/images/what-1.jpg";
import img2 from "src/assets/images/what-2.jpg";
import { useSnackbar } from "notistack";
// import { eduleyApi } from 'src/api/apiConfig';
import { API_ENDPOINTS } from "src/api/apiEndPoints";
import axios from "axios";
import { eduleyApi } from "src/api/apiConfig";
// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  textAlign: "center",
  paddingTop: theme.spacing(20),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("md")]: {
    textAlign: "left",
  },
}));

// ----------------------------------------------------------------------

export default function StudentView({ gotoback,user }) {
  const {
    user: userdata,
    login,
    isLoading,
    getStudentProfile,
    getUser,
  } = useAuth();
  const theme = useTheme();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const isDesktop = useResponsive("up", "md");
  const isLight = theme.palette.mode === "light";
 

  const getstudentdata = async () => {
    let student = {};
    try {
      let res = await eduleyApi.get(API_ENDPOINTS.STUDENT);
      // console.log("student", res);
      student = res.data[0];
      if (student?.email_verified) {
        navigate("/institutes");
      } else {
        verifyyouremail({ auto_generated: true });
      }
    } catch (error) {
      console.log("student", error);
    }
  };
  const verifyyouremail = async (a) => {
    let student = {};
    try {
      let res = await eduleyApi.get(API_ENDPOINTS.STUDENT);
      // console.log("student", res);
      student = res.data[0];
      if (student?.email_verified) {
        navigate("/institutes");

        return;
      }
    } catch (error) {
      console.log("student", error);
    }
    try {
      let res = await axios.post(API_ENDPOINTS.EMAIL_VERIFICATION, {
        user_id: userdata.sub,
        student_id: student.id,
        redirect_url: window.location.origin,
        auto_generated: a.auto_generated,
      });

      if (!a.auto_generated) enqueueSnackbar(res.data.message);
      console.log(res);
    } catch (error) {
      // enqueueSnackbar(JSON.stringify(error.response?.data) || "error", {
      //   variant: "error",
      // });
      console.log(error);
    }
  };
  // const shadow = `-40px 40px 80px ${alpha(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.48)}`;

  useEffect(() => {
    if (!user?.id) {
      login();
    }
  }, [user.id]);

  return (
    <>
      {/* <Grid container spacing={3} alignItems="flex-end">
            <Grid item md={4}>
                <Button
                    onClick={() => gotoback()}
                    fullWidth
                    color="primary"
                    size="large"
                    startIcon={<Iconify icon={'fa:long-arrow-left'} width={24} height={24} />}
                >
                    Back
                </Button>
            </Grid>
        </Grid> */}
      {/* <m.div variants={varFade().inUp}> */}

      
        <>
          <Typography sx={{ color: "#ffffff", textAlign: "center" }}>
           Please wait while we are redirecting to login Page
          </Typography>
        </>
      
      {/* </m.div> */}
      {/* <m.div variants={varFade().inRight}> */}
      {/* </m.div> */}
      {/* <Grid container sx={{ mt: 0.01 }} spacing={3}>
            <Grid item md={8}>

                <TextField
                    fullWidth
                    onChange={e => setEmail(e.target.value)}
                    value={email}
                    placeholder={'Enter your email'}
                />
            </Grid>
            <Grid item md={4}>

      
            </Grid>
        </Grid> */}
    </>
  );
}

// ----------------------------------------------------------------------

ProgressItem.propTypes = {
  progress: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  }),
};

function ProgressItem({ progress }) {
  const { label, value } = progress;

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ mb: 1.5, display: "flex", alignItems: "center" }}>
        <Typography variant="subtitle2">{label}&nbsp;-&nbsp;</Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {fPercent(value)}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          "& .MuiLinearProgress-bar": { bgcolor: "grey.700" },
          "&.MuiLinearProgress-determinate": { bgcolor: "divider" },
        }}
      />
    </Box>
  );
}
